import { useState } from 'react';
import { MdAutoAwesome, MdBolt, MdContentCopy, MdEdit } from 'react-icons/md';
import client from '../api/client';
import { messaggioErrore } from '../utils/apiError';
import { ESEMPI_AI, MODELLI, copiaRegola, daCompletareInCopia } from '../automations/modelli';
import { Button } from './ui';

// Da dove si parte per una nuova automazione. Prima c'era solo il modulo
// completo, con parole come «{{steps.0.text}}» e «tzid» (29/09/2026): qui si può
// descriverla a parole, partire da un modello, o aprire il modulo vuoto.
export default function NuovaAutomazione({ contesto, onScegli, onDaZero, regole = [] }) {
  const [testo, setTesto] = useState('');
  const [inCorso, setInCorso] = useState(false);
  const [errore, setErrore] = useState('');

  const chiedi = async () => {
    setInCorso(true); setErrore('');
    try {
      const { data } = await client.post('/v1/workflows/bozza/', { text: testo, connection: contesto.connection },
        { timeout: 60000 });
      onScegli(data.draft, {
        titolo: 'Bozza preparata dall’AI: controlla e salva',
        testo: data.summary,
        punti: [...data.questions, ...data.missing, ...data.errors],
      });
    } catch (e) {
      setErrore(messaggioErrore(e));
    } finally {
      setInCorso(false);
    }
  };

  return (
    <div className="space-y-5 rounded-xl border bg-surface p-5">
      <section className="space-y-2">
        <h2 className="flex items-center gap-2 text-lg font-semibold"><MdAutoAwesome aria-hidden className="text-brand-600" /> Descrivila a parole</h2>
        <p className="text-sm text-muted">L’AI prepara la regola; tu la controlli, la provi e la accendi quando va bene.</p>
        <textarea className="w-full rounded-lg border bg-surface px-3 py-2 text-sm" rows={3}
          aria-label="Descrivi l’automazione" placeholder="Es. ogni sera alle 21 riassumi il gruppo della scuola e mandamelo"
          value={testo} onChange={e => setTesto(e.target.value)} />
        <div className="flex flex-wrap gap-1">
          {ESEMPI_AI.map(esempio => (
            <button key={esempio} type="button" onClick={() => setTesto(esempio)}
              className="rounded-full border px-2 py-1 text-xs text-muted hover:bg-canvas">{esempio}</button>
          ))}
        </div>
        {errore && <p role="alert" className="text-sm text-danger">{errore}</p>}
        <Button variant="primary" icon={MdAutoAwesome} loading={inCorso} disabled={testo.trim().length < 5}
          onClick={chiedi}>Prepara la bozza</Button>
      </section>

      <section className="space-y-2 border-t pt-4">
        <h2 className="flex items-center gap-2 text-lg font-semibold"><MdBolt aria-hidden className="text-brand-600" /> Parti da un modello</h2>
        <div className="grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
          {MODELLI.map(modello => (
            <button key={modello.id} type="button"
              onClick={() => onScegli(modello.bozza(contesto), {
                titolo: `Modello «${modello.titolo}»: completa e salva`, testo: modello.descrizione, punti: modello.daCompletare,
              })}
              className="rounded-lg border p-3 text-left hover:bg-canvas">
              <span className="block font-medium text-ink">{modello.titolo}</span>
              <span className="mt-1 block text-xs text-muted">{modello.descrizione}</span>
            </button>
          ))}
        </div>
      </section>

      {regole.length > 0 && <section className="space-y-2 border-t pt-4">
        <h2 className="flex items-center gap-2 text-lg font-semibold"><MdContentCopy aria-hidden className="text-brand-600" /> Copia una tua regola</h2>
        <p className="text-sm text-muted">Parti da una regola che già funziona e cambia solo quello che serve.</p>
        <div className="flex flex-wrap gap-2">
          {regole.map(regola => (
            <button key={regola.id} type="button" aria-label={`Copia «${regola.name}»`} className="rounded-lg border px-3 py-2 text-sm hover:bg-canvas"
              onClick={() => onScegli(copiaRegola(regola), {
                titolo: `Copia di «${regola.name}»: adatta e salva`,
                testo: 'È una regola nuova: l’originale resta com’è.', punti: daCompletareInCopia(regola),
              })}>{regola.name}</button>
          ))}
        </div>
      </section>}

      <button type="button" onClick={onDaZero} className="flex items-center gap-2 text-sm text-muted hover:text-ink">
        <MdEdit aria-hidden /> Parto da zero, con il modulo completo
      </button>
    </div>
  );
}
